export default {
    bind(el, binding, vnode) {
        function selectAll(e) {
            e.target.setSelectionRange(0, e.target.value.length) 
        }

        let inputs = el.querySelector('input,select,textarea')

        inputs.addEventListener('focus', selectAll) 
    }
}
  